/**
*
* RedAgendaStackedPresentation
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import selectSpeakerById from 'helpers/selectSpeakerById';
import setLanguageContent from 'helpers/setLanguageContent';

import Wrapper from 'components/Templates/dynamics/Wrapper';
import TagText from 'components/Tag/styles/TagText';

class RedAgendaStackedPresentation extends React.Component {

  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);

  }

  handleClick() {

    const {
      presentation,
      handleShowPresentation,
    } = this.props;

    handleShowPresentation(presentation);
  }


  render() {

    const {
      commonData,
      commonProps,
      presentation,
      speakers,
      language,
      availableTags,
      enableFilters
    } = this.props;

    const {
      startHour,
      startMinutes,
      isBreak,
      trackTitle,
      tags
    } = presentation;
    


    const {
      componentPayload
    } = commonData;

    const {
      companyLogoType,
      sectionId
    } = componentPayload;



    const thisCompanyLogoType = companyLogoType ? companyLogoType : 'colorLogo';

    const thisSpeakerList = presentation && presentation.speakers ? presentation.speakers : '';

    const companiesList = [];
    const companiesListHash = [];

    const speakerContent = !isBreak ? thisSpeakerList.map((speaker, i) => {     

      const thisSpeaker = selectSpeakerById(speakers, speaker);

      if (!thisSpeaker) return '';

      if (thisSpeaker.speakerCompany && thisSpeaker.speakerCompany[thisCompanyLogoType] && !companiesListHash.includes(thisSpeaker.speakerCompany.companieId)) {

        companiesListHash.push(thisSpeaker.speakerCompany.companieId);
        
        companiesList.push(
          (
            <Wrapper
            {...commonProps}
            
            typeOfStyle={'presentationCompanyLogo'}
            key={'presentationCompanyLogo-'+sectionId+thisSpeaker.speakerCompany.companieId}
            editorData={
              {
                editorType: 'presentationCompanyLogo',
                ...commonData
              }
            }
            backgroundImage={thisSpeaker.speakerCompany[thisCompanyLogoType]}
          />
          )
        );
      }

      return (
        <Wrapper
        {...commonProps}
        
        typeOfStyle={'presentationSpeakerNameInline'}
        key={'presentationSpeakerNameInline-'+sectionId+thisSpeaker.speakerId}
        editorData={
          {
            editorType: 'presentationSpeakerNameInline',
            ...commonData
          }
        }
      >
        {`${thisSpeaker.firstName ? thisSpeaker.firstName : ''} ${thisSpeaker.lastName ? thisSpeaker.lastName : ''}${(thisSpeaker.lastName || thisSpeaker.firstName) && thisSpeaker.position  ? ', '+thisSpeaker.position : ''}${(thisSpeaker.lastName || thisSpeaker.firstName || thisSpeaker.position) && thisSpeaker.speakerCompany ? ', '+thisSpeaker.speakerCompany.name : ''}`}
      </Wrapper>
      );
    }) : '';


      
    const presentationContent = (<Wrapper
      {...commonProps}
      
      typeOfStyle={isBreak ? 'presentationBreak' : 'presentationContainer'}
      forceStopPropagation={true}
      editorData={
        {
          editorType: isBreak ? 'presentationBreak' : 'presentationContainer',
          ...commonData
        }
      }
      handleClick={this.handleClick}
    >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'presentationTimeWrapper'}
          editorData={
            {
              editorType: 'presentationTimeWrapper',
              ...commonData
            }
          }
        >

          <Wrapper
            {...commonProps}
            
            typeOfStyle={'presentationTimeStart'}
            editorData={
              {
                editorType: 'presentationTimeStart',
                ...commonData
              }
            }
          >
            {`${startHour}:${startMinutes}`}
          </Wrapper>
          
          

          
        </Wrapper>



        <Wrapper
          {...commonProps}
          
          typeOfStyle={'presentationContentWrapper'}
          editorData={
            {
              editorType: 'presentationContentWrapper',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'presentationTrackTitle'}
            editorData={
              {
                editorType: 'presentationTrackTitle',
                ...commonData
              }
            }
          >
            {trackTitle}
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'presentationTitle'}
            editorData={
              {
                editorType: 'presentationTitle',
                ...commonData
              }
            }
          >
            {setLanguageContent(presentation, 'title', language)}
          </Wrapper>


            <Wrapper
              {...commonProps}
              
              typeOfStyle={'presentationSpeakerWrapper'}
              editorData={
                {
                  editorType: 'presentationSpeakerWrapper',
                  ...commonData
                }
              }
            >
              {speakerContent}
            </Wrapper>

            <Wrapper
              {...commonProps}
              
              typeOfStyle={'presentationCompanyLogoWrapper'}
              editorData={
                {
                  editorType: 'presentationCompanyLogoWrapper',
                  ...commonData
                }
              }
            >
              {companiesList}
            </Wrapper>

            
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'presentationDetailsWrapper'}
              editorData={
                {
                  editorType: 'presentationDetailsWrapper',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'link'}
                editorData={
                  {
                    editorType: 'link',
                    ...commonData
                  }
                }
              >
                {'See the details'}
              </Wrapper>

              <Wrapper
                {...commonProps}
                
                typeOfStyle={'arrow'}
                editorData={
                  {
                    editorType: 'arrow',
                    ...commonData
                  }
                }
              />
            </Wrapper>

            {enableFilters && tags && tags.length ? (

              <Wrapper
                {...commonProps}
                typeOfStyle={'presentationTagsWrapper'}
                editorData={
                  {
                    editorType: 'presentationTagsWrapper',
                    ...commonData
                  }
                }
              >
                {tags.map(tagId => {
  
                  const fullTag = availableTags ? availableTags.find(tag => tag?.tagId === tagId) : '';

                  return fullTag ? (
                    <Wrapper
                      {...commonProps}
                      key={`RedAgendaStackedPresentationTag-${fullTag.tagId}`}
                      typeOfStyle={'filterTagItem'}
                      editorData={
                        {
                          editorType: 'filterTagItem',
                          ...commonData
                        }
                      }
                    >
                      <TagText>
                        {fullTag.title}
                      </TagText>
                  </Wrapper>
                  ) : null;
                })}
              </Wrapper>
            ) : null}

            

        </Wrapper>



    </Wrapper>)

    return presentationContent;
  }
}

RedAgendaStackedPresentation.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  presentation: PropTypes.any,
  dateFrom: PropTypes.object,
  dateTo: PropTypes.object,
  durationInHours: PropTypes.number,
  speakers: PropTypes.array,
  firstHour: PropTypes.number,
  firstHourMinutes: PropTypes.number,
  blurredTop: PropTypes.bool,
  blurredBottom: PropTypes.bool,
  trackCount: PropTypes.object,
  tracksLength: PropTypes.number,
  top: PropTypes.string
};

export default RedAgendaStackedPresentation;
